import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CanalService {

  backendUrl: string = environment.apiUrl;
  url_final: string;


  constructor(private http: HttpClient) {
  }

  consultarProducto(product_id){
    this.url_final = this.backendUrl + "/rmsfe/publicaciones?product_id="
    this.url_final = `${this.url_final}${product_id}`;
    return this.http.get<any>(this.url_final,  {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  obtenerProductosSinMatch(){
    this.url_final = this.backendUrl + "/rmsfe/productos_sin_match"
    return this.http.get<any>(this.url_final,  {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  crearItem(product_id){
    this.url_final = this.backendUrl + "/rmsfe/crear_item_canales"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { product_id })
    .pipe(map(response => {
      return response;
    }));
  }

  relacionarPublicacionConItemExistente(product_id, item_id){
    this.url_final = this.backendUrl + "/rmsfe/relacionar_publicacion_con_item"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { product_id, item_id })
    .pipe(map(response => {
      return response;
    }));
  }

  eliminarRelacionarPublicacionConItem(product_id){
    this.url_final = this.backendUrl + "/rmsfe/eliminar_relacion_publicacion_con_item"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { product_id })
    .pipe(map(response => {
      return response;
    }));
  }

  buscarItem(filtro){
    this.url_final = this.backendUrl + `/rmsfe/buscar_item?filtro=${filtro}`;
    return this.http.get<any>(this.url_final,  {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

}
